var exports = {
  "s5": "xe533113f--24c993--price-container",
  "of": "xe533113f--24c993--strikethrough",
};

module.exports = exports;
